import React from 'react';
import I18n from 'i18n-js';
import ModalDialog from '@reverbdotcom/commons/src/components/modal_dialog';
import window from '@reverbdotcom/commons/src/window_wrapper';
import SanitizedRender from '@reverbdotcom/commons/src/components/sanitized_render';
import { Paths } from './shared/url_helpers';

interface IProps {
  isOpen: boolean;
  onClose: () => void;
  isChecked: boolean;
  updatePrivacySetting: (e) => void;
}

function UserPrivacySettingModal({ isOpen, onClose, isChecked, updatePrivacySetting }: IProps) {
  const mparticleId = window.mParticle.Identity.getCurrentUser?.().getMPID();

  return (
    <ModalDialog
      isOpen={isOpen}
      headerTitle={I18n.t('discovery.privacySettingsModal.privacySettings.title')}
      onRequestClose={onClose}
      useCsrfForm
      formAction="/users/privacy_settings"
    >
      <div className="cms-text size-90 mb-8">
        <h4>
          {I18n.t('discovery.privacySettingsModal.privacySettings.title')}
        </h4>
        <p>
          {I18n.t('discovery.privacySettingsModal.privacySettings.listIntro')}
        </p>
        <ul>
          <li>{I18n.t('discovery.privacySettingsModal.privacySettings.listItem0')}</li>
          <li>{I18n.t('discovery.privacySettingsModal.privacySettings.listItem1')}</li>
          <li>{I18n.t('discovery.privacySettingsModal.privacySettings.listItem2')}</li>
          <li>{I18n.t('discovery.privacySettingsModal.privacySettings.listItem3')}</li>
          <li>{I18n.t('discovery.privacySettingsModal.privacySettings.listItem4')}</li>
          <li>{I18n.t('discovery.privacySettingsModal.privacySettings.listItem5')}</li>
          <li>{I18n.t('discovery.privacySettingsModal.privacySettings.listItem6')}</li>
          <li>{I18n.t('discovery.privacySettingsModal.privacySettings.listItem7')}</li>
        </ul>
        <p>
          <SanitizedRender
            html={I18n.t('discovery.privacySettingsModal.privacySettings.listOutro', {
              cookieLinkOpen: `<a href="${Paths.cookiePolicy.expand({})}" target="_blank">`,
              cookieLinkClose: '</a>',
              privacyLinkOpen: `<a href="${Paths.privacyPolicy.expand({})}" target="_blank">`,
              privacyLinkClose: '</a>',
            })}
          />
        </p>
        <h4>
          {I18n.t('discovery.privacySettingsModal.requiredCookies.title')}
          <span className="color-green ml-2 size-80">{I18n.t('discovery.privacySettingsModal.requiredCookies.alwaysOn')}</span>
        </h4>
        <p>
          {I18n.t('discovery.privacySettingsModal.requiredCookies.text')}
        </p>
        <h4>
          {I18n.t('discovery.privacySettingsModal.personalizedAds.title')}
        </h4>
        <p>
          {I18n.t('discovery.privacySettingsModal.personalizedAds.text')}
        </p>
        <div className="label-with-checkbox">
          {mparticleId && (
            <input
              type="hidden"
              name="mparticle_id"
              value={mparticleId}
            />
          )}
          <input
            type="hidden"
            name="third_party_ad_data_consent"
            value="off"
          />
          <input
            type="checkbox"
            id="third_party_ad_data_consent"
            name="third_party_ad_data_consent"
            onChange={updatePrivacySetting}
            checked={isChecked}
          />
          <label htmlFor="third_party_ad_data_consent">
            {I18n.t('discovery.privacySettingsModal.personalizedAds.checkboxLabel')}
          </label>
        </div>
      </div>
    </ModalDialog>
  );
}

export default UserPrivacySettingModal;
